import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, MapPin, MessageCircle } from "lucide-react";

function waLink(num) {
  if (!num) return null;
  const clean = num.replace(/[^\d+]/g, "").replace(/^\+/, "");
  return `https://wa.me/${clean}`;
}

export default function Footer({ settings }) {
  const s = settings || {};
  const wa = waLink(s.whatsapp_number);

  return (
    <footer className="bg-[#09090b] border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 bg-[#d4af37] flex items-center justify-center font-display font-bold text-black text-lg">B</div>
              <span className="font-display text-xl">Blackline<span className="text-[#d4af37]">.</span></span>
            </div>
            <p className="text-zinc-400 max-w-md leading-relaxed font-light">
              Studio de création digitale. Nous concevons des sites internet, des identités
              visuelles et des solutions métier pour les entreprises ambitieuses.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.2em] text-zinc-500 uppercase mb-4">Navigation</div>
            <ul className="space-y-3 text-sm">
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/">Accueil</Link></li>
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/services">Services</Link></li>
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/a-propos">À propos</Link></li>
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/realisations">Réalisations</Link></li>
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/blog">Journal</Link></li>
              <li><Link className="text-zinc-300 hover:text-white link-gold" to="/devis">Devis</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.2em] text-zinc-500 uppercase mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              {s.contact_email && (
                <li className="flex items-center gap-3">
                  <Mail size={14} className="text-[#d4af37]" />
                  <a href={`mailto:${s.contact_email}`} className="hover:text-white link-gold">{s.contact_email}</a>
                </li>
              )}
              {wa && (
                <li className="flex items-center gap-3" data-testid="footer-whatsapp">
                  <MessageCircle size={14} className="text-[#d4af37]" />
                  <a href={wa} target="_blank" rel="noreferrer" className="hover:text-white link-gold">WhatsApp · {s.whatsapp_number}</a>
                </li>
              )}
              {s.contact_address && (
                <li className="flex items-center gap-3"><MapPin size={14} className="text-[#d4af37]" /> {s.contact_address}</li>
              )}
            </ul>
            <div className="flex gap-3 mt-6">
              {s.social_instagram && (
                <a
                  href={s.social_instagram}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 px-3 h-9 border border-white/10 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors text-xs tracking-wide"
                >
                  <Instagram size={14} /> @Blackline_studio11
                </a>
              )}
              {s.social_linkedin && (
                <a href={s.social_linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 border border-white/10 hover:border-[#d4af37] flex items-center justify-center transition-colors" data-testid="footer-linkedin">
                  <Linkedin size={14} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Blackline Studio — Tous droits réservés.</div>
          <div className="flex items-center gap-6">
            <Link to="/admin" className="hover:text-white">Console admin</Link>
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#d4af37] rounded-full pulse-gold"></span>
              Disponible pour nouveaux projets
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
